<style lang="scss">
.post-reply {}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="post-reply">
    <div class="row">
      <div class="col-12">
        <p>Document unclear? <a :href="post.reply_image_url" target="_blank">Open in new tab</a></p>
      </div>
      <div class="col-12">
        <img width="100%" height="auto" :src="post.reply_image_url" alt="reply image">
      </div>
    </div>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';

export default {
  components: {},
  props: {
    post: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({}),
  },
  mounted() {},
  methods: {},
};
</script>
